import { useQueries, useQuery } from '@tanstack/react-query';
import {
  PartnerWithStartApp,
  StartAppsResponse,
  ZustaendigeStelleResponse
} from '../govos.types';
import { GovosApiRoutes, govosClient } from '../govos-api';

export function usePartnerFetcher() {
  const { data: startApps } = useQuery<StartAppsResponse>({
    queryKey: [GovosApiRoutes.startApps()]
  });

  return useQueries({
    queries: (startApps?.userInfo.startApps ?? []).map((app) => ({
      queryKey: [GovosApiRoutes.zustaendigeStelle(app.appiid)],
      queryFn: () =>
        govosClient
          .get<ZustaendigeStelleResponse>(
            GovosApiRoutes.zustaendigeStelle(app.appiid)
          )
          .then((res) => res.data),
      enabled: (startApps?.userInfo.startApps.length ?? 0) > 0
    })),
    combine: (results) => ({
      data: results
        .flatMap((result, index) => {
          const partner = result.data?.partner;
          if (!partner) return [];
          return {
            ...partner,
            startApp: startApps?.userInfo.startApps[index]
          };
        })
        .filter(Boolean) as PartnerWithStartApp[],
      startApps,
      isLoading: results.some((result) => result.isLoading)
    })
  });
}
